<template>
  <ol class="RunTimelineRunList">
    <li
      v-for="run in runs"
      :key="run.id"
      class="RunTimelineRunList__item"
      :class="{'RunTimelineRunList__item--isCanceled': run.canceled_at}"
      :data-testid="`runTimelineItem-${run.id}`"
    >
      <RouterLink
        class="RunTimelineRunList__itemLink"
        :to="getRouteForRun(run.id)"
        @click.prevent="openModal(getRouteForRun(run.id))"
      >
        <CrewListLabel
          :crews="run.crews"
        />
        <time
          class="RunTimelineRunList__itemTime"
          :datetime="run.start_at"
        >
          {{ formatRunTimeRange(run, run.court?.timezone || Timezone["America/New_York"]) }}
        </time>
        <RunLocation
          :court="run.court"
        />
      </RouterLink>
      <div class="RunTimelineRunList__itemBannerContainer">
        <Transition>
          <div
            v-if="run.canceled_at"
            class="RunTimelineRunList__itemBanner"
            data-testid="runBanner"
          >
            Canceled
          </div>
        </Transition>
      </div>
    </li>
  </ol>
</template>

<script lang="ts" setup>
import getRouteForRun from "@/lib/utils/route/getRouteForRun.ts";
import useModalStore from "@/stores/useModalStore.ts";
import { RunForTimeline } from "@/stores/useRunCarouselStore";
import { Timezone } from "@shared/lib/constants/timezones";
import formatRunTimeRange from "@shared/lib/utils/date/formatRunTimeRange";
import CrewListLabel from "./CrewListLabel.vue";
import RunLocation from "./RunLocation.vue";

const {
  runs,
} = defineProps<{
  runs: Array<RunForTimeline>,
}>();

const {
  openModal,
} = useModalStore();
</script>

<style lang="scss" scoped>
.RunTimelineRunList {
  display: grid;
  gap: 1px;
}

.RunTimelineRunList__item {
  --iconColor: var(--themeColorNeutral300);
  position: relative;
  outline: dashed 1px var(--themeColorNeutral100);
}

.RunTimelineRunList__itemLink {
  display: grid;
  gap: 10px;
  padding: 16px;

  transition: 350ms opacity;

  .RunTimelineRunList__item--isCanceled & {
    opacity: 0.4;
  }
}

.RunTimelineRunList__itemTime {
  font-size: 24px;
  font-weight: var(--fontWeightMedium);
  font-stretch: var(--fontWidthExtended);
}

.RunTimelineRunList__itemBannerContainer {
  position: absolute;
  top: 0;
  right: 0;

  height: 100%;
  aspect-ratio: 1;
  overflow: hidden;

  pointer-events: none;
}

.RunTimelineRunList__itemBanner {
  position: absolute;
  top: 32px;
  right: 32px;
  transform: translate(50%, -50%) rotate(45deg);
  transform-origin: center;

  width: 120%;
  padding: 6px 0 5px;

  background-color: var(--themeColorNeutral200);
  color: var(--themeColorNeutral900);

  font-size: 14px;
  font-weight: var(--fontWeightMedium);
  text-align: center;
  text-transform: uppercase;

  &.v-enter-active,
  &.v-leave-active {
    transition: 350ms cubic-bezier(0.65, 0, 0.35, 1);
    transition-property: transform, opacity;
  }

  &.v-enter-from,
  &.v-leave-to {
    transform: translate(calc(50% + 36px), calc(-50% - 36px)) rotate(45deg);
    opacity: 0;
  }
}
</style>
